import React from 'react';
import { useParams } from 'react-router';
import useStyles from "../../../Styles";
import ContractDetails from '../Contracts/ContractDetails';
import SchedulesTable from "./SchedulesTable";

const ViewSchedules = (props) => {

    const classes = useStyles();
    const params = useParams();

    return (
        <main className={classes.layout}>
            <ContractDetails contractId={params.contractId} />
            <SchedulesTable />
        </main>
    )

}

export default ViewSchedules;